import request from "@/utils/request";
export function getList(data) {
    return request({
        url: '/api/portal/v1/portal/supply/hall/list',
        method: 'post',
        data
    })
}
export function getDetail(data) {
    return request({
        url: '/api/portal/v1/portal/selectBiddInfo',
        method: 'post',
        data
    })
}

export function login(data) {
    return request({
        url: '/api/portal/v1/apiUserInfo/login',
        method: 'post',
        data
    })
}